import React from "react";
import { Link } from "react-router-dom";
import { useTheme } from "../lib/theme";

const SECTIONS = [
  {
    title: "Sections",
    links: [
      { label: "Featured observances", href: "/#featured" },
      { label: "Calendar explorer", href: "/#explorer" },
      { label: "Why it matters", href: "/#why" },
      { label: "Preservation statement", href: "/#preservation" },
      { label: "Resources", href: "/#resources" },
      { label: "Submit a date", href: "/#submit" },
    ],
  },
  {
    title: "About this archive",
    links: [
      { label: "Editorial principles", href: "/#why" },
      { label: "Submission guidelines", href: "/#submit" },
      { label: "Blog", href: "/blog", isLink: true },
      { label: "Support this project", href: "/support", isLink: true },
      { label: "Our supporters", href: "/supporters", isLink: true },
    ],
  },
];

export const Footer = () => {
  const { theme } = useTheme();
  const logoSrc = theme === "dark" ? "/wnbf-logo-light.png" : "/wnbf-logo.png";
  return (
    <footer
      role="contentinfo"
      data-testid="footer"
      style={{
        marginTop: "4rem",
        borderTop: "1px solid hsl(var(--line))",
        background: "hsl(var(--bg-deep))",
      }}
    >
      <div className="shell" style={{ padding: "4rem 1.5rem 2rem" }}>
        <div style={{
          display: "grid",
          gridTemplateColumns: "minmax(0, 1.6fr) repeat(2, minmax(0, 1fr))",
          gap: "2.5rem",
        }} className="footer-grid">
          <div>
            <Link to="/" style={{ textDecoration: "none", color: "hsl(var(--ink))" }}>
              <img
                src={logoSrc}
                alt="Will Not Be Forgotten"
                className="wnbf-emblem"
                style={{ width: "100%", maxWidth: 280, height: "auto", display: "block" }}
              />
            </Link>
            <p style={{ marginTop: "1.25rem", maxWidth: 420, fontSize: "0.95rem", lineHeight: 1.6 }}>
              A public-memory project preserving the holidays, observances, and historic milestones
              that shape a fuller American story — and that are too often pushed to the margins.
            </p>
          </div>
          {SECTIONS.map((section) => (
            <div key={section.title}>
              <h4 style={{
                fontSize: "0.78rem",
                letterSpacing: "0.18em",
                textTransform: "uppercase",
                color: "hsl(var(--accent))",
                fontFamily: "var(--font-body)",
                fontWeight: 600,
                marginBottom: "1rem",
              }}>
                {section.title}
              </h4>
              <ul style={{ margin: 0, padding: 0, listStyle: "none", display: "flex", flexDirection: "column", gap: 8 }}>
                {section.links.map((l) => (
                  <li key={l.label}>
                    {l.isLink ? (
                      <Link to={l.href} style={{ color: "hsl(var(--ink-soft))", textDecoration: "none", fontSize: "0.92rem" }}>{l.label}</Link>
                    ) : (
                      <a href={l.href} style={{ color: "hsl(var(--ink-soft))", textDecoration: "none", fontSize: "0.92rem" }}>{l.label}</a>
                    )}
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div id="citation" style={{
          marginTop: "3rem",
          paddingTop: "2rem",
          borderTop: "1px solid hsl(var(--line))",
          display: "flex",
          flexWrap: "wrap",
          justifyContent: "space-between",
          gap: "1rem",
          fontSize: "0.82rem",
          color: "hsl(var(--muted))",
        }}>
          <div>
            <strong style={{ color: "hsl(var(--ink-soft))", fontWeight: 500 }}>Citation note.</strong>{" "}
            Entries are starting points, not final words. Always check primary sources before teaching, organizing, or citing.
          </div>
          <div>
            © {new Date().getFullYear()} Will Not Be Forgotten · An independent civic-memory project.
          </div>
        </div>
      </div>
      <style>{`
        @media (max-width: 760px) {
          .footer-grid { grid-template-columns: 1fr !important; }
        }
      `}</style>
    </footer>
  );
};
